
import { defineComponent } from "vue";
import Report from "./Report.vue";
import ContainerReportFilter from "./ContainerReportFilter.vue";
import { ReportType } from "./ReportType";
import ContainerReportInfoDialog from "@/components/info/ContainerReportInfoDialog.vue";

export default defineComponent({
  components: {
    Report,
    ContainerReportFilter,
    ContainerReportInfoDialog,
  },
  computed: {
    reportType(): any {
      return ReportType.ContainerReport;
    },
  },
  methods: {
    onReport(planId: any, options: any) {
      this.$refs.reportComponent.onReport(planId, options);
    },
    onStop() {
      this.$refs.reportComponent.onStop();
    },
  },
});
